import { useContext } from "react";
import { LanguageContext } from "../../../../../Context/Language.Context";
import TheButton from "../../../UI/TheButton/TheButton";
import styles from './FeatureResources.module.css'
import BodyContainer from "../../../UI/BodyContainer/BodyContainer";
import { logEvent } from "../../../../../Utils/google-analytics";

const FeatureHeroResources = ({ product }) => {

    const { language } = useContext(LanguageContext);
    const isEnglish = language === "EN";

    // const links = product.specSheetLinkEN || product.specSheetLinkFR;
    const links = product.specSheetLink;
    const validateSpecSheetLink = (specLink) => {
        if (specLink === '' || specLink === null) {
            return null
        } else {
            return specLink;
        }
    }

    const testSpecLinks = validateSpecSheetLink(links);
    // console.log(testSpecLinks)
    const resources = [
        {
            resourceTitle: isEnglish ? "Specification Sheet" : "Fiche Technique",
            resourceUrl: product.specSheetLink
        },

    ].filter(item => item.resourceUrl && item.resourceTitle);
    const handleExternalLinkClick = (resource, product) => {
        logEvent('RESOURCE_CLICKED', {
            product_name: product.title,
            product_category: product.category,
            product_subcategory: product.subcategory,
            destination_url: resource.resourceUrl,
            resource_type: resource.resourceTitle,
        });
    };

    return (
        testSpecLinks !== null && (
            <div className={styles.heroResourcesSectionWrapper}>
                {resources.map((resource, idx) => (
                    <a
                        key={idx}
                        href={resource.resourceUrl}
                        className={styles.resourceLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleExternalLinkClick(resource, product)}
                    >
                        <TheButton
                            animated="true"
                            icon
                            buttonIcon
                            iconName="externalLink"
                            iconText={resource.resourceTitle}
                            styleName="lightButtonIcon"
                        />
                    </a>
                ))}
            </div>
        )
    );
};

export default FeatureHeroResources;